/**
 * Asynchronously loads the component for NurturingCandidatesSegmentsPage
 */

import { lazyLoad } from 'utils/loadable';

export const NurturingCandidatesSegmentsPage = lazyLoad(
  () => import('./index'),
  module => module.NurturingCandidatesSegmentsPage,
);
